import MasterService from "./MasterService";

const CommonService = {
    ...MasterService,

    getDocumentListing(params: any) {
        return this.post('/agency/api/agency_document_list', params)
    },

    getDashboardCount(params: any) {
        return this.post('/agency/api/dashboardCount',params);
    },

    getDashboardGraphData(params: any) {
        return this.post('/agency/api/graphViewData',params);
    },

    getPendingPayment(params: any) {
        return this.post('/agency/api/pendingpayment',params);
    },
    
    getMasterConfig() {
        return this.get('/agency/api/masterConfig')
    },

    getDataFromDocument(params: object) {
        return this.post('/common/uploadAndReadDocument', params)
    },

    getMMVList(params: object) {
        return this.post('/agency/api/getMMV', params)
    },

    addDocument(params: object) {
        return this.post('/lead/addDocumentWeb', params);
    },

    getNotificationCount() {
        return this.post('/agency/api/unread_count_history')
    },

    getNotificationList(params: object) {
        return this.post('/agency/api/get_notification_history', params);
    },

    readNotificationHistory(params: object){
        return this.post('/agency/api/read_notification_history', params);
    },

    addDocumentWeb(params: object) {
        return this.post('/lead/addDocument', params);
    },

    // Agent ID Apis

    getMasterConfigID(headers?: any) {
        return this.get('/common/master/config', undefined, headers)
    },

    getReporteeID(params: any) {
        return this.post('/agency/get_reportees', params)
    },

    getInsurerListID(params: any) {
        return this.post('/Insurer/getInsurerList', params)
    },

    getBrandListID(params: any) {
        return this.post('/mmv/getBrandList', params)
    },

    getFormFieldID(params: any, headers?: any) {
        return this.post('/common/getFormFields', params, headers)
    },

    getNotificationCountID(params: any) {
        return this.post('/notification/fcm/unread_count_history', params)
    },
    getDocUploadUrl(params: object){
        return this.post('/agency/api/uploadLeadDocImagesId',params);
    }

}


export default CommonService;